import { render, staticRenderFns } from "./ChatWazzup.vue?vue&type=template&id=f2c1182c&scoped=true"
import script from "./ChatWazzup.vue?vue&type=script&lang=js"
export * from "./ChatWazzup.vue?vue&type=script&lang=js"
import style0 from "./ChatWazzup.vue?vue&type=style&index=0&id=f2c1182c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c1182c",
  null
  
)

export default component.exports